import { render, staticRenderFns } from "./StepperNewAppointment.vue?vue&type=template&id=8d5ff85e&scoped=true&"
import script from "./StepperNewAppointment.vue?vue&type=script&lang=js&"
export * from "./StepperNewAppointment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d5ff85e",
  null
  
)

export default component.exports